import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Button from '@atlaskit/button/default/button';

const messages = defineMessages({
	orgChart: {
		id: 'user-profile-card.ViewReportingLineButton.orgChart',
		defaultMessage: 'Org chart',
		description:
			'Label for the button on the user profile card that reveals the reporting-line (org chart) view',
	},
});

interface ViewReportingLineButtonProps {
	/** Reveals the reporting-line view. */
	onClick: () => void;
	/** Id of the reporting-line region this button controls (for `aria-controls`). */
	controls?: string;
	testId?: string;
}

/**
 * Button that slides the card from the profile view to the reporting-line (org chart) view. Shown
 * on the Manager row of the front pane of {@link ProfileCardSlider}.
 */
export function ViewReportingLineButton({
	onClick,
	controls,
	testId,
}: ViewReportingLineButtonProps): React.JSX.Element {
	const intl = useIntl();

	return (
		<Button
			onClick={onClick}
			aria-controls={controls}
			testId={testId}
			spacing="compact"
			appearance="subtle"
		>
			{intl.formatMessage(messages.orgChart)}
		</Button>
	);
}
